<template>
  <div>
    <section role="main" class="empty">
      <div class="container">
        <div class="row icon-tabs">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item">
              <router-link to="/executive" class="nav-link"
                ><img src="/img/icons/executives.png" alt="Executives" />
                Executives</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/company" class="nav-link active"
                ><img src="/img/icons/companies.png" alt="Companies" />
                Companies</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/news" class="nav-link"
                ><img src="/img/icons/deals.png" alt="News" /> News</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/deals-transactions" class="nav-link"
                ><img src="/img/icons/deals.png" alt="Deals & Transactions" />
                Deals & Transactions</router-link
              >
            </li>
            <li class="nav-item">
              <router-link to="/listing" class="nav-link"
                ><img src="/img/book.png" style="height: 23px" />
                Listing</router-link
              >
            </li>
            <!-- <li class="nav-item">
              <router-link to="/commentaries" class="nav-link"
                ><img src="/img/icons/commentaries.png" alt="Commentaries" />
                Commentaries</router-link
              >
            </li> -->
            <li class="nav-item">
              <router-link to="/interesting-bites" class="nav-link"
                ><img
                  src="/img/icons/interesting.png"
                  alt="Interesting Facts"
                />
                Interesting Facts</router-link
              >
            </li>
            <!-- NOTE: Temporary hide the open position tab. -->
            <!-- <li class="nav-item">
              <router-link to="/open-positons-new" class="nav-link"
                ><img src="/img/icons/position.png" alt="Open Position" /> Open
                Positons</router-link
              >
            </li> -->
            <li class="">
              <a
                class="nav-link"
                style="
                  font-weight: bold !important;
                  margin-top: 8px;
                  font-size: 13px;
                  color: #1f3342;
                  margin-left: 290px;
                "
              >
                {{ count }}</a
              >
            </li>
          </ul>
          <div class="tab-content mb-3">
            <div>
              <!--  -->
              <div class="container px-0">
                <div class="row">
                  <div class="col-lg-8 col-sm-8">
                    <input
                      type="text"
                      class="search-query"
                      style="border: 0px none; width: 100%; padding-left: 0"
                      v-on:keyup.enter="getList(0)"
                      placeholder="Search"
                      v-model="searchObj.keyword"
                    />
                  </div>
                  <div
                    class="col-lg-4 col-sm-4 col-6 text-right company-offcanvas"
                  >
                    <button
                      class="menuButton"
                      id="openOffcanvas"
                      v-on:click="openCloseModel()"
                    >
                      <div class="filter-title-name">Build My Search</div>
                    </button>
                  </div>
                </div>
                <hr class="mt-0 mb-2" />
              </div>
              <div v-if="showDidYouMean" class="did-you-mean">
                Did you mean: <span class="did-you-mean-prompt">{{ searchedPrompt }}</span>
              </div>
              <!-- <hr /> -->
              <div class="col-12 row mt-4">
                <div
                  class="col-lg-4 col-sm-4"
                  v-for="(data, index) in list"
                  :key="index"
                >
                  <div class="rectangle-box">
                    <div class="row" style="height: 115px">
                      <div class="col-lg-3 col-sm-3 col-1 pr-2 text-center">
                        <a>
                          <img
                            v-if="data.company_logo"
                            :src="
                              data.company_logo
                                ? data.company_logo
                                : '/img/user-pic.png'
                            "
                            alt=""
                            class="round"
                          />
                          <img
                            v-if="!data.company_logo"
                            :src="
                              data.company_logo
                                ? data.company_logo
                                : '/img/company.png'
                            "
                            alt=""
                            class="round"
                          />
                        </a>
                        <a
                          class="mr-1"
                          style="margin-left: -3px"
                          :title="data.country ? data.country.country_name : ''"
                        >
                          <country-flag
                            :country="
                              data.country ? data.country.country_code : 'US'
                            "
                          />
                        </a>
                      </div>
                      <div class="col-lg-7 col-sm-7 col-9 px-2">
                        <a
                          style="cursor: pointer"
                          v-on:click="goToView('/company-detail/' + data.id)"
                        >
                          <div
                            style="display: initial !important"
                            :title="data.company_name ? data.company_name : '-'"
                            class="client-name"
                          >
                            {{ data.company_name ? data.company_name : "-" }}
                          </div>
                          <div
                            class="address"
                            style="display: initial !important"
                          >
                            <div
                              :title="
                                data.industry ? data.industry.industry_name : ''
                              "
                            >
                              {{
                                data.industry
                                  ? $helperService.getText(
                                      data.industry.industry_name,
                                      20
                                    )
                                  : ""
                              }}
                            </div>

                            <div>
                              {{
                                data.city
                                  ? $helperService.getText(
                                      data.city.city_name,
                                      30
                                    ) + ","
                                  : ""
                              }}
                              {{
                                data.country
                                  ? $helperService.getText(
                                      data.country.country_name,
                                      30
                                    )
                                  : ""
                              }}
                            </div>
                            <div>
                              {{
                                data.company_type
                                  ? data.company_type + " Company"
                                  : "-"
                              }}
                            </div>
                            <div>
                              Employee Size:
                              {{ data.company_size ? data.company_size : "-" }}
                            </div>
                          </div>
                        </a>
                      </div>
                      <div class="col-lg-2 col-sm-2 col-2 px-2 text-center">
                        <!-- <span v-if="data.is_fav == 0"
                          ><img
                            v-on:click="addToFavorite(data)"
                            src="/img/favorite.png"
                            width="18"
                            height="18"
                            alt="Favorite"
                            style="opacity: 0.5"
                        /></span>
                        <span v-if="data.is_fav == 1"
                          ><img
                            v-on:click="addToFavorite(data)"
                            src="/img/favorite-fill.png"
                            width="18"
                            height="18"
                            alt="Favorite Fill"
                        /></span> -->
                        <input
                          type="checkbox"
                          v-on:click="addToFavorite(data)"
                          :checked="data.is_fav == 1"
                        />
                      </div>
                    </div>
                    <div class="col-lg-12 col-sm-12">
                      <span class="update-date"
                        >Last Updated :
                        {{
                          $helperService.getFormatedDate(data.updated_on)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
            <ErrorComponent @retry="getList(0)" ref="errorComponent" />
            <div class="row mx-0 mb-4">
              <div class="col-lg-12 mt-5 text-center">
                <div class="page-bottom-pagination text-right">
                  <Pagination
                    @page-change="pageChange"
                    @items-per-page-change="itemsPerPageChange"
                    ref="listPagination"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Company Section Filter View start here -->
  <div class="navbar company-offcanvas">
    <div
      :class="
        isOpenModel
          ? 'navbar-collapse offcanvas-collapse open'
          : 'navbar-collapse offcanvas-collapse close'
      "
    >
      <div class="inner-filter-close">
        <div class="row">
          <div class="col-lg-6 col-sm-6 col-6 text-left">
            <h6
              class="mb-0"
              style="font-size: 15px; padding-top: 2px; color: #de4a38"
            >
              Company
            </h6>
          </div>
          <div class="col-lg-6 col-sm-6 col-6" id="closeOffcanvas">
            <button
              class="navbar-toggler menuButton"
              v-on:click="openCloseModel()"
            >
              <img src="/img/cross.png" width="22" height="22" />
            </button>
          </div>
        </div>
      </div>
      <div class="form-group mb-3 px-4" v-if="selectedFilters.length">
        <div class="selected-filters d-flex flex-wrap mt-2">
          <span
            v-for="(filter, index) in selectedFilters"
            :key="index"
            class="selected-chip"
            style="cursor: pointer"
            @click="removeSelectedFilter(filter)"
          >
            {{ filter.name }} <span style="margin-left: 5px">&times;</span>
          </span>
        </div>
      </div>
      <div class="inner-data">
        <div class="filter-modal">
          <div class="overflowScroll">
            <div id="accordion" class="accordion">
              <div class="card mb-0">
                <!-- Current Company -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseOne"
                >
                  <a class="card-title"> Current Company</a>
                </div>
                <div id="collapseOne" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <Multiselect
                      v-model="searchObj.new_company_ids"
                      :options="companyList"
                      :multiple="true"
                      placeholder="Select"
                      label="company_name"
                      track-by="company_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCompanyName($event)"
                      @input="onCompanyChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>

                <!-- ComapnySegment -->
                <div
                  v-if="isShowSegment"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseTwo"
                >
                  <a class="card-title">Company Segment</a>
                </div>
                <div id="collapseTwo" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(segment, index) in segmentList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.segment_ids.includes(
                            segment.id
                          ),
                          'btn-success active':
                            !searchObj.segment_ids.includes(segment.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="segment.name"
                          :value="segment.id"
                          v-model="searchObj.segment_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              segment.id,
                              'segment',
                              segment.name
                            )
                          "
                        />
                        {{ segment.name }}
                      </label>
                    </div>
                  </form>
                </div>
                
                <!-- Industry -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  href="#collapseThree"
                >
                  <a class="card-title"> Industry </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(industry, index) in getDisplayedIndustries()"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj?.industry_ids.includes(
                            industry?.id
                          ),
                          'btn-success active':
                            !searchObj?.industry_ids.includes(industry?.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="industry.industry_name"
                          :value="industry.id"
                          v-model="searchObj.industry_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              industry.id,
                              'industry',
                              industry.industry_name
                            )
                          "
                        />
                        {{ industry.industry_name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!--sub sector -->
                <div
                  v-if="isShowSubsector"
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThree"
                >
                  <a class="card-title"> Tech Focus </a>
                </div>
                <div id="collapseThree" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap gap-2">
                      <label
                        v-for="(subsector, index) in subsectorList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.subsector_ids.includes(
                            subsector.id
                          ),
                          'btn-success active':
                            !searchObj.subsector_ids.includes(subsector.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="subsector.industry_name"
                          :value="subsector.id"
                          v-model="searchObj.subsector_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              subsector.id,
                              'subsector',
                              subsector.industry_name
                            )
                          "
                        />
                        {{ subsector.industry_name }}
                      </label>
                    </div>
                    <!-- View more Button -->
                    <div class="mt-2 text-right">
                      <span
                        v-if="!showAllIndustries"
                        @click="handleShowMore"
                        style="
                          cursor: pointer;
                          font-size: 14px;
                          color: black;
                          font-weight: 500;
                        "
                      >
                        view more
                      </span>
                    </div>
                  </form>
                </div>
                <!-- Location -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFour"
                >
                  <a class="card-title"> Location </a>
                </div>
                <div id="collapseFour" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <!-- <label class="mb-1" style="font-weight: normal">Search Location</label> -->
                    <!-- <div class="tags-container">
                    <input data-role='tags-input' placeholder="Search Location" data-placeholder="Search Location"
                      value="" />
                  </div> -->
                    <multiselect
                      v-model="searchObj.country_ids"
                      :options="cityList"
                      :multiple="true"
                      placeholder="Select"
                      label="country_name"
                      track-by="country_name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchCityName($event)"
                      @input="onLocationChange"
                      :show-labels="false"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Tags -->
                <div
                  class="card-header collapsed px-1"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSeventeen"
                >
                  <a class="card-title"> Tags </a>
                </div>
                <div id="collapseSeventeen" class="card-body collapse show">
                  <div class="form-group mb-3">
                    <multiselect
                      v-model="searchObj.skill_ids"
                      :options="skill_list"
                      :multiple="true"
                      placeholder="Select"
                      label="name"
                      track-by="name"
                      value-prop="id"
                      searchable="true"
                      mode="tags"
                      @search-change="searchSkillName($event)"
                      @input="onSkillChange"
                      :show-labels="true"
                    >
                    </multiselect>
                  </div>
                </div>
                <!-- Company Type -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseThirteen"
                >
                  <a class="card-title"> Company Type </a>
                </div>
                <div id="collapseThirteen" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(comapnyType, index) in company_types"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj?.company_types.includes(comapnyType),
                          'btn-success active':
                            !searchObj?.company_types.includes(comapnyType),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapnyType"
                          :value="comapnyType"
                          v-model="searchObj.company_types"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapnyType,
                              'company_type',
                              comapnyType
                            )
                          "
                        />
                        {{ comapnyType }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Company Size -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFifteen"
                >
                  <a class="card-title"> Company Size </a>
                </div>
                <div id="collapseFifteen" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(comapanySize, index) in company_sizes"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger':
                            searchObj?.company_sizes.includes(comapanySize),
                          'btn-success active':
                            !searchObj?.company_sizes.includes(comapanySize),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="comapanySize"
                          :value="comapanySize"
                          v-model="searchObj.company_sizes"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              comapanySize,
                              'company_size',
                              comapanySize
                            )
                          "
                        />
                        {{ comapanySize }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Deal Stage -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseFourteen"
                >
                  <a class="card-title"> Deal Stage </a>
                </div>
                <div id="collapseFourteen" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(dealStage, index) in dealStageList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.deal_stage_ids.includes(
                            dealStage.id
                          ),
                          'btn-success active':
                            !searchObj.deal_stage_ids.includes(dealStage.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="dealStage.name"
                          :value="dealStage.id"
                          v-model="searchObj.deal_stage_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              dealStage.id,
                              'deal_stage',
                              dealStage.name
                            )
                          "
                        />
                        {{ dealStage.name }}
                      </label>
                    </div>
                  </form>
                </div>
                <!-- Region  -->
                <div
                  class="card-header collapsed px-3"
                  data-toggle="collapse"
                  data-parent="#accordion"
                  href="#collapseSixten"
                >
                  <a class="card-title"> Region </a>
                </div>
                <div id="collapseSixten" class="card-body collapse show">
                  <form>
                    <div class="d-flex flex-wrap">
                      <label
                        v-for="(region, index) in regionList"
                        :key="index"
                        class="btns btn-block"
                        :class="{
                          'btn-danger': searchObj.region_ids.includes(
                            region.id
                          ),
                          'btn-success active':
                            !searchObj.region_ids.includes(region.id),
                        }"
                      >
                        <input
                          type="checkbox"
                          class="d-none"
                          :name="region.region_name"
                          :value="region.id"
                          v-model="searchObj.region_ids"
                          autocomplete="off"
                          @change="
                            handleToggle(
                              region.id,
                              'region',
                              region.region_name
                            )
                          "
                        />
                        {{ region.region_name }}
                      </label>
                    </div>
                  </form>
                </div>
              <!-- New filter will be add here  -->
              </div>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between align-items-center px-3 posfixed"
          >
            <button
              v-on:click="
                getList(0);
                openCloseModel();
              "
              class="apply-btn mr-2"
            >
              Apply
            </button>
            <button
              v-on:click="
                resetFilter();
                openCloseModel();
              "
              type="button"
              class="apply-btn"
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
// import { Field } from "vee-validate";
import CountryFlag from "vue-country-flag-next";
export default {
  name: "Executive",
  components: {
    ErrorComponent,
    Pagination,
    Multiselect,
    // Field,
    CountryFlag,
  },
  data() {
    return {
      id: this.$route.params.id,
      showDidYouMean: false,
      loader: true,
      isShowSubsector: false,
      showAllIndustries: false,
      isShowSegment: false,
      count: 0,
      searchedPrompt: "",
      company_types: [
        "Public",
        "Private",
        "Education",
        "Government",
        "Not-for-Profit",
        "Venture Funded",
        "PE Backed",
      ],
      company_sizes: [
        "1-10",
        "11-50",
        "51-200",
        "201-500",
        "501-1000",
        "1001-5000",
        "5001-10000",
        "10000+",
      ],
      searchObj: {
        type: "",
        keyword: "",
        industry_ids: [],
        company_sizes: [],
        company_types: [],
        country_ids: [],
        deal_stage_ids: [],
        subsector_ids: [],
        region_ids: [],
        new_company_ids: [],
        segment_ids: [],
        skill_ids: [],
      },
      offset: -1,
      list: [],
      cityList: [],
      industryList: [],
      regionList: [],
      companyList: [],
      skill_list: [],
      industryKeyword: "",
      cityKeyword: "",
      companySizeKeyword: "",
      companyTypeKeyword: "",
      skillKeyword: "",
      dealStageList: [],
      dealStageKeyword: "",
      selectedFilters: [],
      isOpenModel: false,
      companyKeyword: "",
    };
  },
  mounted() {
    this.globelSearchResult();
    this.industrylist();
    this.getDealStageList();
    this.getRegionlist();
    this.CityList();
    this.companylist();
    this.getskillList();
    if (this.id) {
      this.$shareService.getMapValueAndRemove("company_page_filter");
      this.getCompamyDetail(this.id);
    } else {
      this.getList(0);
    }
  },
  watch: {
    "searchObj.new_company_ids"(newVal) {
      if (newVal.length === 1) {
        const selectedCompanyId = newVal[0];
        this.getSegmentList(selectedCompanyId);
      } else {
        this.segmentList = [];
        this.isShowSegment = false;
        this.searchObj.segment_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
          (f) => f.type !== "segment"
        );
      }
    },

    "searchObj.industry_ids"(newVal) {
      if (newVal.length === 1) {
        const selectedIndustryId = newVal[0];
        this.onIndustryChange(selectedIndustryId);
      } else {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.searchObj.subsector_ids = [];
        this.selectedFilters = this.selectedFilters.filter(
          (f) => !(f.type === "subsector")
        );
      }
    },

    // Scroll hide when Offcanvas open
    isOpenModel(newVal) {
    if (newVal) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }

  },
  methods: {
    getDisplayedIndustries() {
      return this.showAllIndustries
        ? this.industryList
        : this.industryList.slice(0, 15);
    },
    handleShowMore() {
      this.showAllIndustries = true;
    },
    openCloseModel() {
      this.isOpenModel = !this.isOpenModel;
    },
    removeSelectedFilter(filter) {
      console.log(filter);
      // alert(filter);
      if (filter.type === "industry") {
        this.searchObj.industry_ids = this.searchObj.industry_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_type") {
        this.searchObj.company_types = this.searchObj.company_types.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "company_size") {
        this.searchObj.company_sizes = this.searchObj.company_sizes.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "deal_stage") {
        this.searchObj.deal_stage_ids = this.searchObj.deal_stage_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "location") {
        this.searchObj.country_ids = this.searchObj.country_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "subsector") {
        this.searchObj.subsector_ids = this.searchObj.subsector_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "region") {
        this.searchObj.region_ids = this.searchObj.region_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "segment") {
        this.searchObj.segment_ids = this.searchObj.segment_ids.filter(
          (id) => id !== filter.id
        );
      } else if (filter.type === "skill") {
        this.searchObj.skill_ids = this.searchObj.skill_ids.filter(
          (id) => id !== filter.id
        );
      }

      // Later you can handle other types like 'company' etc.

      // This line ensures it's removed visually too
      this.selectedFilters = this.selectedFilters.filter(
        (f) => !(f.id === filter.id && f.type === filter.type)
      );
    },
    onLocationChange(selectedIds) {
      console.log(this.cityList, "set city on selected filter");
      this.selectedFilters = this.selectedFilters.filter(
        (filter) =>
          filter.type !== "location" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "location"
        );
        if (!exists) {
          const country = this.cityList.find((c) => c.id === id);
          if (country) {
            this.selectedFilters.push({
              id: country.id,
              name: country.country_name,
              type: "location",
            });
          }
        }
      });
    },
    onSkillChange(selectedIds) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type !== "skill" || selectedIds.includes(filter.id)
      );

      // Add any new ones
      selectedIds.forEach((id) => {
        const exists = this.selectedFilters.some(
          (f) => f.id === id && f.type === "skill"
        );
        if (!exists) {
          const skill = this.skill_list.find((c) => c.id === id);
          if (skill) {
            this.selectedFilters.push({
              id: skill.id,
              name: skill.name,
              type: "skill",
            });
          }
        }
      });
    },
    searchSkillName(e) {
      if (e) {
        this.skillKeyword = e;
        this.getskillList();
      }
    },
    getskillList() {
      var obj = {};
      if (this.skillKeyword) {
        obj.keyword = this.skillKeyword;
      }
      this.$api
        .getAPI({
          _action: "/skills/list",
          _body: obj,
        })
        .then((res) => {
          this.skill_list = this.$helperService.removePlaceholderOptions(res);
          // keep picked skills that fall outside this page of results, so their
          // tags still show a name
          this.selectedFilters
            .filter((f) => f.type === "skill" && !this.skill_list.some((s) => s.id === f.id))
            .forEach((f) => this.skill_list.push({ id: f.id, name: f.name }));
        })
        .catch(() => {});
    },
    handleToggle(id, type, name) {
      const exists = this.selectedFilters.find(
        (item) => item.id === id && item.type === type
      );

      if (!exists) {
        this.selectedFilters.push({
          id: id,
          name: name,
          type: type,
        });
      } else {
        this.selectedFilters = this.selectedFilters.filter(
          (item) => !(item.id === id && item.type === type)
        );
      }
    },
    resetFilter() {
      this.searchObj = {};
      this.searchObj.type = "";
      this.searchObj.keyword = "";
      this.searchObj.industry_ids = [];
      this.searchObj.company_sizes = [];
      this.searchObj.company_types = [];
      this.searchObj.country_ids = [];
      this.searchObj.deal_stage_ids = [];
      this.searchObj.subsector_ids = [];
      this.searchObj.region_ids = [];
      this.searchObj.new_company_ids = [],
      this.searchObj.segment_ids = [];
      this.searchObj.skill_ids = [];
      this.isShowSubsector = false;
      this.selectedFilters = [];
      this.showDidYouMean = false;
      this.getList(0);
    },

    goToView(url) {
      this.$shareService.setMapValue("company_page_filter", this.searchObj);
      this.$router.push(url);
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];

      if (this.offset != page) {
        this.searchObj.offset = page;
      } else {
        this.searchObj.offset = page;
      }

      if (!this.searchObj.industry_ids) {
        this.searchObj.industry_ids = [];
      }
      if (!this.searchObj.company_sizes) {
        this.searchObj.company_sizes = [];
      }
      if (!this.searchObj.country_ids) {
        this.searchObj.country_ids = [];
      }
      if (!this.searchObj.subsector_ids) {
        this.searchObj.subsector_ids = [];
      }
      if (!this.searchObj.deal_stage_ids) {
        this.searchObj.deal_stage_ids = [];
      }
      if (!this.searchObj.company_types) {
        this.searchObj.company_types = [];
      } else {
        // this.searchObj.company_type = this.searchObj.company_type.toLowerCase();
      }
      if (this.id) {
        this.searchObj.id = this.id;
      }
      var filter_obj = this.$shareService.getMapValue("company_page_filter")
        ? this.$shareService.getMapValue("company_page_filter")
        : null;
      if (filter_obj) {
        this.searchObj = filter_obj;
        this.$shareService.getMapValueAndRemove("company_page_filter");
      }
      this.$api
        .getAPI({
          _action: "/company/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.count = res.count;
          for (var i in res.list) {
            if (res.list[i].company_type) {
              res.list[i].company_type =
                res.list[i].company_type.charAt(0).toUpperCase() +
                res.list[i].company_type.substring(1).toLowerCase();
            }
          }
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          // if (this.id) {
          //   for (var j in this.list) {
          //     if (this.list[j].id == this.id) {
          //       this.list.splice(j, 1);
          //     }
          //   }
          // }
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(
                  this.searchObj.offset + 1
                );
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Company are available");
            this.$refs.errorComponent.updateListLoader(false);
          }
          console.log("searchObj", this.searchObj);
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    globelSearchResult() {
      let filters = this.$shareService.getMapValueAndRemove("global_search_filter");
      if (filters && Object.keys(filters).length > 0) {
        
        // Did you mean
        this.showDidYouMean = filters.flag;
        this.searchedPrompt = filters.prompt;

        let industryId =
          filters.iid && filters.iid != 0 ? Number(filters.iid) : "";
        if (industryId) {
          this.searchObj.industry_ids.push(industryId);
          this.selectedFilters.push({
            id: industryId,
            name: "",
            type: "industry",
          });

            let subsectorid =
              filters.ssid && filters.ssid != 0 ? Number(filters.ssid) : "";   // Subsector
            if (subsectorid) {
              this.searchObj.subsector_ids.push(subsectorid);
              this.selectedFilters.push({
                id: subsectorid,
                name: "",
                type: "subsector",
              });  
            }
            this.getSubsectorList(industryId);
        }

        let countryId =
          filters.cid && filters.cid != 0 ? Number(filters.cid) : "";
        if (countryId) {
          this.searchObj.country_ids.push(countryId);
          this.selectedFilters.push({
            id: countryId,
            name: "",
            type: "location",
          });
        }

        let stageId =
          filters.sid && filters.sid != 0 ? Number(filters.sid) : "";
        if (stageId) {
          this.searchObj.deal_stage_ids.push(stageId);
          this.selectedFilters.push({
            id: stageId,
            name: "",
            type: "deal_stage",
          });
        }

        let companyType = filters.ctype ?? "";
        if (companyType) {
          this.searchObj.company_types.push(
            this.$helperService.getCompanyTypeLabel(companyType)
          );
          this.selectedFilters.push({
            id: this.$helperService.getCompanyTypeLabel(companyType),
            name: this.$helperService.getCompanyTypeLabel(companyType),
            type: "company_type",
          });
        }

        let regionid =
          filters.rid && filters.rid != 0 ? Number(filters.rid) : "";
        if (regionid) {
          this.searchObj.region_ids.push(regionid);
          this.selectedFilters.push({
            id: regionid,
            name: "",
            type: "region",
          });
        }

        let companySize = filters.cs ?? "";
        if (companySize) {
          this.searchObj.company_sizes.push(companySize);
          this.selectedFilters.push({
            id: companySize,
            name: companySize,
            type: "company_size",
          });
        }

        // dashboard sentence search: tags (company skills), and the picked
        // names so the chips read right away
        (filters.skills || []).forEach((skill) => {
          this.searchObj.skill_ids.push(skill.id);
          this.selectedFilters.push({ id: skill.id, name: skill.name, type: "skill" });
        });
        if (filters.labels) {
          this.selectedFilters.forEach((filter) => {
            if (!filter.name && filters.labels[filter.type]) {
              filter.name = filters.labels[filter.type];
            }
          });
        }
      }
    },
    getCompamyDetail(id) {
      this.$api
        .getAPI({
          _action: "/company/detail/" + id,
        })
        .then((res) => {
          if (res.industry_id) {
            this.searchObj.industry_ids.push(res.industry_id);
            this.selectedFilters.push({
              id: res.industry_id,
              name: res?.industry?.industry_name,
              type: "industry",
            });
            if (this.searchObj.industry_ids.length === 1) {
              const selectedIndustryId = this.searchObj.industry_ids[0];
              this.onIndustryChange(selectedIndustryId);
            }
          }
          if (res.company_type) {
            this.searchObj.company_types.push(
              this.$helperService.getTitleCase(res.company_type)
            );
            this.selectedFilters.push({
              id: this.$helperService.getTitleCase(res.company_type),
              name: this.$helperService.getTitleCase(res.company_type),
              type: "company_type",
            });
          }
          if (res.company_size) {
            this.searchObj.company_sizes.push(res.company_size);
            this.selectedFilters.push({
              id: res.company_size,
              name: res?.company_size,
              type: "company_size",
            });
          }
          if (res.country_id) {
            this.searchObj.country_ids.push(res.country_id);
            this.selectedFilters.push({
              id: res.country_id,
              name: res?.country?.country_name,
              type: "country",
            });
          }
          this.getList(0);
        })
        .catch(() => {});
    },
    addToFavorite(data) {
      var obj = {};
      obj.company_id = data.id;
      this.$api
        .putAPI({
          _action: "/add/company/fav",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          return (data.is_fav = data.is_fav == 1 ? 0 : 1);
          // this.getList(0);
          // this.$router.push("/company");
        })
        .catch(() => {});
    },
    searchCompanyType(e) {
      this.companyTypeKeyword = e;
      this.industrylist();
    },
    searchCompanySize(e) {
      this.companySizeKeyword = e;
      this.industrylist();
    },
    searchIndustryName(e) {
      this.industryKeyword = e;
      this.industrylist();
    },
    searchDealStage(e) {
      this.dealStageKeyword = e;
      this.getDealStageList();
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
    closesub(e) {
      if (!e) {
        this.searchObj.subsector_ids = [];
      }
    },
    onIndustryChange(selectedIndustryId) {
      if (selectedIndustryId) {
        this.subsectorList = [];
        this.isShowSubsector = false;
        this.getSubsectorList(selectedIndustryId);
      } else {
        this.isShowSubsector = false;
      }
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/list",
        })
        .then((res) => {
          this.industryList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "industry"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.subsectorList = this.$helperService.removePlaceholderOptions(res);

          // Only show subsector dropdown if there are subsectors(of industry) available
          const selectedIndustry = this.industryList.find(
            industry => industry.id == id
          );
          console.log('selectedIndustry-', JSON.stringify(selectedIndustry));
          if (this.subsectorList.length > 0 && selectedIndustry?.industry_name == 'Technology') { // Show only for the technology in company as client said
            this.isShowSubsector = true;
          } else {
            this.isShowSubsector = false;
          }

          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "subsector"
                ) {
                  this.selectedFilters[i].name = res[j].industry_name;
                }
              }
            }
          }          
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },
    getDealStageList() {
      this.$api
        .getAPI({
          _action: "/deal/stage/list",
        })
        .then((res) => {
          this.dealStageList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "deal_stage"
                ) {
                  this.selectedFilters[i].name = res[j].name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
    getRegionlist() {
      var obj = {};
      if (this.regionKeyword) {
        obj.keyword = this.regionKeyword;
      }
      this.$api
        .getAPI({
          _action: "/region/list",
          _body: obj,
        })
        .then((res) => {          
          this.regionList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "region"
                ) {
                  this.selectedFilters[i].name = res[j].region_name;
                }
              }
            }
          }          
        })
        .catch(() => {});
    },    
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },    
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = this.$helperService.removePlaceholderOptions(res);
        })
        .catch(() => {});
    }, 
    getSegmentList(id) {
      this.$api
        .getAPI({
          _action: "/segment/list/" + id,
        })
        .then((res) => {
          res = res.list;
          this.segmentList = this.$helperService.removePlaceholderOptions(res);

          // Only show segment dropdown if there are segment(of company) available
          if (this.segmentList.length > 0) {
            this.isShowSegment = true;
          } else {
            this.isShowSegment = false;
          }
        })
        .catch(() => {
          this.isShowSubsector = false;
        });
    },       
    CityList() {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      this.$api
        .getAPI({
          _action: "/country/list",
          _body: obj,
        })
        .then((res) => {
          // if (this.cityKeyword) {
          //   this.cityList = res;
          // } else {
          //   // this.cityList = [];
          // }
          this.cityList = this.$helperService.removePlaceholderOptions(res);
          if (this.selectedFilters && this.selectedFilters.length > 0) {
            for (var i in this.selectedFilters) {
              for (var j in res) {
                if (
                  res[j].id == this.selectedFilters[i].id &&
                  this.selectedFilters[i].type == "location"
                ) {
                  this.selectedFilters[i].name = res[j].country_name;
                }
              }
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
.multiselect {
  background: #f0f0f0;
  height: 35px;
  border: 1px solid;
}
[data-toggle="buttons"] > .btns input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btns input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: relative !important;
  left: 0 !important;
}
label.btns.btn-block.btn-success.active,
label.btns.btn-block.btn-danger {
  border-radius: 15px;
  font-size: 11px;
  color: black;
  margin: 2px;
  padding: 4px 12px;
  font-weight: normal;
  cursor: pointer;
}
label.btns.btn-block.btn-success.active {
  background-color: #e2f0d9;
}
label.btns.btn-block.btn-danger {
  background: #d2ecff;
}
.btn-block {
  display: inline-block;
  width: auto;
}
.card .card-body {
  padding: 2px;
  margin: 0;
}
.input-tags {
  width: 100%;
  padding: 15px;
  display: block;
  margin: 0 auto;
}
.tags-container .tag {
  position: relative;
  padding-right: 24px;
  padding-top: 0.4em;
  padding-bottom: 0.4em;
  padding-left: 0.4em;
  font-size: 85%;
  margin-left: 0.25rem;
}
.card-title {
  font-size: 13px;
}

.selected-chip {
  background-color: #d2ecff; /* light green */
  border-radius: 15px;
  font-size: 12px;
  color: black;
  margin: 2px;
  padding: 10px 20px;
  font-weight: normal;
  cursor: pointer;
}

.remove-icon {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
}
</style>
